export const Regex = {
  stringWithoutSpaceAndWithSpecialCharacter: /^[A-zÁ-ù\\s\\-\\_]{1,100}$/gm,
  string50WithoutSpaceAndWithSpecialCharacter: /^[A-zÁ-ù\\s\\-\\_]{1,50}$/gm,
  date: /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/gm,
  time: /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/gm,
  lada: /^[0-9]{0,3}$/gm,
  phone: /^[0-9]{0,8}$/gm,
  cellPhone: /^[0-9]{10,10}$/gm,
  ext: /^[0-9]{0,5}$/gm,
  email: /^[a-zA-Z0-9_!#$%&'+=?{|}~^.-]+@[a-zA-Z0-9.-]/gm,
  rfc: /^[0-9a-zA-Z]{1,13}$/gm,
  zipCode: /^[0-9]{5,5}$/gm,
  street: /^[A-zÁ-ù0-9\s-.()/]{1,100}$/gm,
  address: /^[A-zÁ-ù0-9\s-.()/]{1,50}$/g,
  internalNumber: /^[a-zA-Z0-9\\s\\-\\.\\(\\)\\/]{1,20}$/gm,
  CLABE: /^[0-9]{18,18}$/gm,
};
